var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('TitleComponent'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-body text-center"},[_c('h1',[_vm._v("Oops !")]),_c('p',[_vm._v("The page you're looking for doesn't exist")])])])])
}]

export { render, staticRenderFns }